import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SecurityService } from '../services/security.service';

export const authGuard: CanActivateFn = async (_route, state) => {
  const security = inject(SecurityService);
  const router = inject(Router);
  const user = await security.getUser();
  if (user) return true;
  // Preserve the attempted URL so the login page can route back here on success.
  // Only forward internal paths (start with /) and skip the auth pages themselves
  // to avoid bouncing the user to /login → /login.
  const attempted = state.url;
  const isInternal = attempted.startsWith('/') && !attempted.startsWith('//');
  const isAuthPage = attempted === '/login' || attempted.startsWith('/login?')
                  || attempted === '/signup' || attempted.startsWith('/signup?');
  return router.createUrlTree(['/login'], {
    queryParams: isInternal && !isAuthPage ? { returnUrl: attempted } : undefined,
  });
};
